import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReportNote from '../../../../components/ReportNote';
import ReportCard from '../../../../components/ReportCard';
import StyledNotesContainer from '../StyledNotesContainer';

const StatNotes = ({ isLhb, pitcherId, levelId }) => {
    const { t: translate } = useTranslation();

    const [hasStatNotes, setHasStatNotes] = useState(true);

    return hasStatNotes ? (
        <ReportCard title={translate('pitcher-overview.sections.stat-notes')}>
            <StyledNotesContainer>
                <ReportNote
                    type={levelId === 8 ? 'oppp' : 'mnhp'}
                    section={isLhb ? 202 : 201}
                    playerId={pitcherId}
                    levelId={levelId}
                    hasDataCallback={setHasStatNotes}
                />
            </StyledNotesContainer>
        </ReportCard>
    ) : <></>;
};

export default StatNotes;
